module.exports = __webpack_public_path__ + "img/Feed the future_horizontal blue.8ed1cd18.jpg";